import React, {useState} from 'react';
import Pagination from "react-bootstrap/cjs/Pagination";
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import './index.css';

export default function DommusTabelaPaginadaControlada({
  tamanhoPagina,
  setTamanhoPagina,
  pagina,
  setPagina,
  linhasCorpo,
  linhasCabecalho,
  linhasRodape,
  tamanhoTotal,
  customClasses,
  optionsTabela,
  stepTamanho,
  tamanhoMinimo
  }) {
	const inicioArray = tamanhoPagina ? (pagina - 1) * tamanhoPagina : 0;
	const tamanhoArray = tamanhoPagina ? ((inicioArray + tamanhoPagina) < tamanhoTotal) ? (inicioArray + tamanhoPagina) : (tamanhoTotal) : 0;
	const paginaFinal = tamanhoPagina ? Math.ceil(tamanhoTotal / tamanhoPagina) : 0;
  const itensPaginacao = [];

	const page_config = {
		limite: 15,
		min_paginas: 3
	}
	let ultimaPaginaFoiOculta = false;
	for (let numeroPagina = 1; numeroPagina <= paginaFinal; numeroPagina++) {
		const paginaItem = <Pagination.Item key={numeroPagina} active={numeroPagina === pagina} onClick={() => {
			setPagina(numeroPagina)
		}}>
			{numeroPagina}
		</Pagination.Item>;

		let numeroPaginaOculta;

		if(
			paginaFinal <= page_config.limite ||
			(pagina-2 <= numeroPagina && pagina+2 >= numeroPagina) ||
			pagina === numeroPagina ||
			numeroPagina <= page_config.min_paginas ||
			numeroPagina > paginaFinal-page_config.min_paginas
		) {
			itensPaginacao.push(paginaItem);
			ultimaPaginaFoiOculta=false;
		} else {
			if(!ultimaPaginaFoiOculta) {

				if(pagina < numeroPagina) {
					numeroPaginaOculta = pagina + page_config.min_paginas + 2
				} else {
					numeroPaginaOculta = pagina - page_config.min_paginas - 2
				}

				if(numeroPaginaOculta > paginaFinal || numeroPaginaOculta < 1) {
					numeroPaginaOculta = pagina;
				}

				let paginaOculta = <Pagination.Item key={numeroPagina} active={false} onClick={() => {
					setPagina(numeroPaginaOculta);
				}}>
					...
				</Pagination.Item>;
				itensPaginacao.push(paginaOculta)
				ultimaPaginaFoiOculta = true;
			}
		}

	}

	const opcoesTabela = Object.assign({
		responsive: true,
		bordered: true,
		hover:true
	}, optionsTabela);

	return (
		<>
			<div className={"card card-table " + customClasses}>
				<Table className={"tabela-dommus"}{...opcoesTabela} responsive="sm"> 
					<thead className={"thead-dark"}>
					{linhasCabecalho}
					</thead>
					<tbody>
					{
						linhasCorpo
					}
					</tbody>
					<tfoot className={"tfoot-dark"}>
					{linhasRodape}
					</tfoot>
				</Table>
			</div>
			<div className='d-sm-flex justify-content-between'>
				<Form.Group controlId="paginationPageSize">
					<Form.Control type="number" step={stepTamanho || 5} min={tamanhoMinimo || 5} value={tamanhoPagina}
												size="sm" style={{width: '40%'}}
												onChange={(e) => {
													setTamanhoPagina(e.target.value)
												}}/>
					<Form.Text className="text-muted">
						Itens por página.
					</Form.Text>
				</Form.Group>
				<Pagination>
					<Pagination.First onClick={() => {
						setPagina(1)
					}}/>
					<Pagination.Prev onClick={() => {
						if (pagina !== 1) {
							setPagina(pagina - 1);
						}
					}}/>
					{itensPaginacao}
					<Pagination.Next onClick={() => {
						if (pagina !== paginaFinal) {
							setPagina(pagina + 1);
						}
					}}/>
					<Pagination.Last onClick={() => {
						setPagina(paginaFinal)
					}}/>
				</Pagination>
			</div>
		</>
	)
};
